module.exports = __webpack_public_path__ + "img/current-course-background.4ec968a8.png";